<template>
  <div class="page-form">
    <h3 class="title">现金客户批导</h3>
    <affix>
      <div class="tools">
        <form-button type="default" icon="form-advance" @click="confirmImport">导入</form-button>
        <form-button type="default" icon="form-advance" @click="$emit('change-action', 'query')">返回</form-button>
      </div>
    </affix>

    <div class="table-container">
      <TableCommon
        title="批导明细"
        :custome-config="() => vxeShowCustom('xTable')"
      >
        <template #button>
          <!-- <table-button name="export" tip="打印" @click="printBatch" /> -->
          <!-- <table-button name="export" tip="导出" @click="exportExcel" /> -->
        </template>
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="300"
          align="center"
          size="mini"
          :empty-render="{name: 'NotData'}"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="batchNum"
        >
        <template #status="{ row }">
            <el-link size="mini" :type="row.status == 'V001' ? 'success' : 'danger'" effect="dark">
              <!-- {{ row.status == 'V001' ? '启用' : '禁用' }} -->
              {{ row.status_text }}
            </el-link>
          </template>
        </vxe-grid>
      </TableCommon>
    </div>
  </div>
</template>

<script>
import pageConfig, { pageSearch } from './config/rewardCustomer'
import { bpReward } from '@/api/sap/reward-policy'
import tableMixins from '@/utils/tableMixins'
export default {
  mixins: [tableMixins],
  props: ['batchNum'],
  data() {
    return {
      pageSearch,
      gridOptions: {
        // 新增
        columns: [
          // { field: 'message', title: '处理消息', width: 80 },
        ],
        data: []
      }
    }
  },
  created() {
    const params = {
      message: {
        title: '处理消息',
      },
      ...pageConfig
    }
    console.log(`output->pageConfig`,pageConfig)
    delete params.remain_amount
    delete params.atp_amount
    delete params.billing_amount
    delete params.status
    this.initPage(params)
  },
  methods: {
    async confirmImport(){
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        mode: 'IMPORT',
        data: this.batchNum
      }
      const { message, msgtype, data } = await bpReward(params)
      if (msgtype === 'S') {
        this.$emit('change-action', 'batch', data)
        this.$message.success(message)
      } else {
        this.$message.error(message)
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/reward-policy/reward-customer-import.vue